import Crud from '../views/Material/Crud'
import Entity from '../views/Material/Add'
import View from '../views/Material/View'

let routes = {
    path: '/materiais',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/materiais/add',
            name: 'NewMaterial',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Material',
                breadcrumb: [
                    {
                        text: 'Materiais',
                        active: false,
                        to: '/materiais',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/materiais/edit/:id?',
            name: 'EditMaterial',
            component: Entity,
            meta: {
                pageTitle: 'Editar Material',
                breadcrumb: [
                    {
                        text: 'Materiais',
                        active: false,
                        to: '/materiais',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/materiais/view/:id?',
            name: 'ViewMaterial',
            component: View,
            meta: {
                pageTitle: 'Visualizar Material',
                breadcrumb: [
                    {
                        text: 'Materiais',
                        active: false,
                        to: '/materiais',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/materiais',
            name: 'list-materiais',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Materiais',
                breadcrumb: [
                    {
                        text: 'Materiais',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
